import React from "react";
import prevmxImg from "../images/DJI_0723.JPG";
import constructImg from "../images/DJI_0022.JPG";
import emergencyImg from "../images/pexels-swastikarora-15206136.jpg";
import landscapeImg from "../images/IMG_1852.JPEG";
import cleaningImg from "../images/pexels-karola-g-4239110.jpg";

export default function Home() {
    return (
        <section className="home">
            <div className="hero">
            <div className="hero-overlay" />
            <img
            className="hero-img"
            src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=1600&auto=format&fit=crop"
            alt="Skyscraper construction with cranes"
            />
            <div className="hero-content container">
            <h1>Facility services built on precision and trust.</h1>
            <p>Maintenance, tenant improvements, and 24/7 response across Southern Arizona.</p>
            <a className="btn-primary" href="/request">Request Service</a>
            </div>
            </div>


            <div className="container grid-3 features">
            <FeatureCard
            title="Preventive Maintenance"
            text="Proactive inspections and scheduled service that prevent costly repairs, minimize downtime, and extend asset life."
            img={prevmxImg}
            />
            <FeatureCard
            title="Construction Support"
            text="Build‑outs and renovations delivered safely, on budget, and on time."
            img={constructImg}
            />
            <FeatureCard
            title="Emergency Response"
            text="Rapid dispatch for leaks, power issues, HVAC failures, and more."
            img={emergencyImg}
            />
            </div>
            <div className="container grid-1 features">
                <FeatureCard
                title="Cleaning Services"
                text="Professional interior cleaning for commercial properties, including kitchens, restrooms, offices, and high-traffic public areas. We handle routine sanitation, deep cleaning, and post-use cleanup with consistent, reliable service"
                img={cleaningImg}
                />
                <FeatureCard
                title="Landscape Maintenance & Debris Removal"
                text="Our full-service team offers professional landscape trimming, cleanup, and debris removal for commercial and residential properties. We manage overgrowth, storm debris, and construction waste with prompt, reliable service; keeping your exterior spaces clean, safe, and presentable year-round."
                img={landscapeImg}
                />
            </div>
        </section>
    );
}

function FeatureCard({ title, text, img }) {
    return (
        <article className="card">
        <img className="card-img" src={img} alt="Service preview" />
        <div className="card-body">
        <h3>{title}</h3>
        <p>{text}</p>
        </div>
        </article>
    );
}